
  export default {
    methods: {
      randomWidth () {
        const widths = [
          'width-40',
          'width-45',
          'width-50',
          'width-55',
          'width-60'
        ];
        const randNumber = Math.floor(Math.random() * (widths.length - 0 + 1) + 0);
        return widths[randNumber];
      }
    }
  };
